module.exports = __webpack_public_path__ + "img/3.1daa6d58.png";